import type { Icon } from '@phosphor-icons/react';
import {
  CertificateIcon,
  ChatsCircleIcon,
  FileMagnifyingGlassIcon,
  InfoIcon,
  LockKeyIcon,
  MegaphoneIcon,
  QuestionIcon,
  ShieldCheckIcon,
  SquaresFourIcon,
  UploadSimpleIcon,
} from '@phosphor-icons/react';

export const ICONES_DE_CATEGORIA: Record<string, Icon> = {
  enviar: UploadSimpleIcon,
  consultar: FileMagnifyingGlassIcon,
  denunciar: MegaphoneIcon,
  emitir: CertificateIcon,
  falar: ChatsCircleIcon,
  'dados-pessoais': LockKeyIcon,
  informacao: InfoIcon,
  perguntas: QuestionIcon,
  seguranca: ShieldCheckIcon,
};

export const ICONE_PADRAO: Icon = SquaresFourIcon;

export function iconeDaCategoria(token?: string | null): Icon {
  return (token && ICONES_DE_CATEGORIA[token]) || ICONE_PADRAO;
}
